module.exports = __webpack_public_path__ + "static/G1N4-576ef546354d57b63fbaca2e69d97ec8.jpg";